import { render, staticRenderFns } from "./UpscaleLabPanel.vue?vue&type=template&id=2c3de48a&scoped=true"
import script from "./UpscaleLabPanel.vue?vue&type=script&lang=js"
export * from "./UpscaleLabPanel.vue?vue&type=script&lang=js"
import style0 from "./UpscaleLabPanel.vue?vue&type=style&index=0&id=2c3de48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3de48a",
  null
  
)

export default component.exports